// assets/quick-view.js
console.log('3-quick-view.js loaded');
class QuickView {
  constructor() {
    this.modal = document.getElementById('quickViewModal');
    this.modalInstance = null;
    if (this.modal) {
      this.init();
    }
  }

  init() {
    // Initialize Bootstrap modal
    this.modalInstance = new bootstrap.Modal(this.modal);

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.quick-view-trigger');
      if (trigger) {
        e.preventDefault();
        const handle = trigger.dataset.productHandle;
        if (handle) {
          this.loadProductData(handle);
        }
      }
    });

    // Handle form submission
    this.modal.querySelector('.product-form')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleAddToCart(e.target);
    });
  }

  async loadProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      this.updateQuickView(product);
      this.modalInstance.show();
    } catch (error) {
      console.error('Error loading product data:', error);
    }
  }

  updateQuickView(product) {
    // Update title
    this.modal.querySelector('.product-title').textContent = product.title;

    // Update main image
    this.modal.querySelector('.main-image').innerHTML = `
      <img src="${product.featured_image}" 
           class="img-fluid" 
           alt="${product.title}"
           loading="lazy">
    `;

    // Update thumbnails
    if (product.images.length > 1) {
      this.modal.querySelector('.thumbnail-list').innerHTML = product.images
        .map(image => `
          <div class="thumbnail">
            <img src="${image}" 
                 class="img-fluid" 
                 alt=""
                 loading="lazy"
                 onclick="this.closest('.product-gallery').querySelector('.main-image img').src='${image}'">
          </div>
        `).join('');
    }

    // Update price
    this.modal.querySelector('.product-price').innerHTML = `
      <span class="current-price">${this.formatMoney(product.price)}</span>
      ${product.compare_at_price > product.price ? 
        `<s class="compare-price">${this.formatMoney(product.compare_at_price)}</s>` : 
        ''}
    `;

    // Update description
    this.modal.querySelector('.product-description').innerHTML = product.description;

    // Update variant selector
    if (product.variants.length > 1) {
      this.updateVariantSelects(product);
    }

    // Update form ID
    const formIdInput = this.modal.querySelector('input[name="id"]');
    formIdInput.value = product.variants[0].id;
  }

  updateVariantSelects(product) {
    const variantSelectsContainer = this.modal.querySelector('.variant-selects');
    const options = product.options_with_values;

    variantSelectsContainer.innerHTML = options
      .map((option, index) => `
        <div class="form-group mb-3">
          <label for="option${index}">${option.name}</label>
          <select class="form-control" 
                  id="option${index}" 
                  name="options[${option.name}]"
                  data-option-index="${index}">
            ${option.values.map(value => 
              `<option value="${value}">${value}</option>`
            ).join('')}
          </select>
        </div>
      `).join('');

    // Add variant change listeners
    this.initVariantSelectors(product);
  }

  async handleAddToCart(form) {
    try {
      const formData = new FormData(form);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (response.ok) {
        // Success - update cart and show message
        this.showMessage('Product added to cart!', 'success');
        // Optionally refresh cart here
      } else {
        throw new Error(result.description);
      }
    } catch (error) {
      this.showMessage(error.message, 'error');
    }
  }

  formatMoney(cents) {
    return (cents/100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  showMessage(message, type = 'success') {
    const alertDiv = document.createElement('div');
    alertDiv.className = `alert alert-${type} alert-dismissible fade show`;
    alertDiv.innerHTML = `
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `;
    this.modal.querySelector('.modal-body').insertAdjacentElement('afterbegin', alertDiv);
  }
}

// Initialize QuickView
document.addEventListener('DOMContentLoaded', () => {
  new QuickView();
});
